var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcancelbold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6162 16.384L3.61621 5.38398L5.38398 3.61621L16.384 14.6162L14.6162 16.384Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38379 16.384L16.3838 5.38398L14.616 3.61621L3.61602 14.6162L5.38379 16.384Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcancelbold);
export default __webpack_public_path__ + "static/media/icon.cancel.bold.39742ca8e2ecce8e9f51dd0f67c275b5.svg";
export { ForwardRef as ReactComponent };